import { lazy } from 'react';

export const RewardRemovePlayersForm = lazy(
  () => import('./RewadRemovePlayersForm'),
);
